export default __webpack_public_path__ + "static/media/header_5.4364c15d.jpg";